module.exports = __webpack_public_path__ + "static/media/man-valet.ac95c318.png";